import React from 'react'

export const CardBody = props => (
  <div className={`card-body ${props.className || ''}`} style={props.style}>
    {props.children}
  </div>
)

export default CardBody
